import { Button, Form, Grid, Input } from 'antd';
import { ContentFilters } from 'components';
import { StandardItemsWrapper } from 'components/content-filters/content-filters.styles';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { SportsFilterFormField, SportsFilterFormValues } from './types';

const { useBreakpoint } = Grid;

type SportsFilterFormProps = {
  formId: string;
  handleFilter: (values: SportsFilterFormValues) => void;
  initialValues: SportsFilterFormValues;
  closeModal?: () => void;
};

export const SportsFilterForm = ({
  formId,
  handleFilter,
  initialValues,
  closeModal,
}: SportsFilterFormProps) => {
  const [validateTrigger, setValidateTrigger] = useState(['onSubmit']);
  const [form] = Form.useForm<SportsFilterFormValues>();
  const { t } = useTranslation();
  const screens = useBreakpoint();

  const onReset = () => {
    form.resetFields();
  };

  const handleOnFinish = (values: SportsFilterFormValues) => {
    handleFilter(values);
    closeModal?.();
  };

  return (
    <Form<SportsFilterFormValues>
      id={formId}
      name={formId}
      form={form}
      layout='vertical'
      onFinish={handleOnFinish}
      initialValues={initialValues}
      onFinishFailed={() => {
        setValidateTrigger(['onChange']);
      }}
      validateTrigger={validateTrigger}
    >
      <ContentFilters.FormItemsWrapper>
        <StandardItemsWrapper>
          <Form.Item<SportsFilterFormValues>
            label={t('sports.formFields.sportName.label')}
            name={SportsFilterFormField.SportName}
          >
            <Input placeholder={t('sports.formFields.sportName.placeholder')} />
          </Form.Item>
        </StandardItemsWrapper>
      </ContentFilters.FormItemsWrapper>

      {screens.lg && (
        <ContentFilters.ButtonsWrapper>
          <Button type='primary' htmlType='submit'>
            {t('bookings.buttons.filter', { count: 1 })}
          </Button>
          <Button onClick={onReset}>{t('bookings.buttons.reset')}</Button>
        </ContentFilters.ButtonsWrapper>
      )}
    </Form>
  );
};
